(() => {
  const KEY = 'stlukes:recent';
  const CAP = 12;

  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(stored) ? stored.filter((h) => typeof h === 'string') : [];
    } catch (error) {
      // Private mode, a full quota, or someone else's data in the key.
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP)));
    } catch (error) {
      /* not being able to remember is not worth breaking the page over */
    }
  };

  // ---------- record ----------

  const current = document.querySelector('[data-recent-record]')?.dataset.recentRecord;
  if (current) {
    write([current, ...read().filter((handle) => handle !== current)]);
  }

  // ---------- render ----------

  const rail = document.querySelector('[data-recent]');
  if (!rail) return;

  const track = rail.querySelector('[data-recent-track]');
  const limit = Number(rail.dataset.recentCount) || 6;
  const exclude = rail.dataset.recentExclude || '';

  // Read after recording, so the product being looked at is filtered out
  // rather than shown back to the shopper.
  const handles = read()
    .filter((handle) => handle !== exclude)
    .slice(0, limit);

  if (handles.length < 2) return;

  const root = window.Shopify?.routes?.root || '/';

  const parser = new DOMParser();

  const card = async (handle) => {
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=stlukes-card-slot`);
    if (!response.ok) return null; // deleted, unpublished, or renamed since it was viewed

    // The Section Rendering API wraps the section in its own element. The card
    // has to be the grid item itself, or it loses the row sizing that keeps
    // prices aligned.
    const html = await response.text();
    return parser.parseFromString(html, 'text/html').querySelector('.pcard')?.outerHTML || null;
  };

  Promise.all(handles.map((handle) => card(handle).catch(() => null))).then((cards) => {
    const found = cards.filter(Boolean);
    if (found.length < 2) return;

    track.innerHTML = found.join('');
    rail.hidden = false;
  });

  rail.querySelector('[data-recent-clear]')?.addEventListener('click', () => {
    write([]);
    rail.hidden = true;
  });
})();
